import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import { contractorList } from "constants/contractor";

export const addContractor = async (bodyData) => {
  try {
    const res = await API.add_contractor(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getContractorList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.contractor_list(pageNum, filters);
    dispatch({ type: contractorList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: contractorList,
      payload: error?.response?.data || error,
    });
  }
};

export const getContractorById = async (id) => {
  try {
    const res = await API.get_contractor_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateContractorById = async (id, bodyData) => {
  try {
    const res = await API.edit_contractor(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteContractorById = async (id) => {
  try {
    const res = await API.delete_contractor_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}